var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_507_455",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_507_455",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAACzUlEQVR4nO2ay4oTQRSGG5cqUbwt1Fdw5UbcFP3/ldCLrBwRxRfQiM8wYIJP4XjBjeMsfIQZhdFxvGyEiG5cjTMKmrgTwWk5pCShbSdV6a7qLPqHAyHpVNXXdVLn0omiWrVqBVOSJMcBXCTZI7kCYI3kazHz+rH5bEEpdSyaJymlDgO4QXKD5C7J1NJ2Abwg2dFaH6oa4DaAHw6LzzUAQ9kpHRqI5FWSO0UBcmw7juMr3gGUUgdJPvQAkN2hB81m84AXiFardcT4tFcIjmFeNZvNEz5Oo/ehIDiG6cvcpbmT3J3QEBzby3a7vb8wiPhrhRCpsbtlnE5VQ6TGzS7PBJEkSQPA56oBOLYdiV3OIBLs5mDxacZ6s0Tt4RwsPM2419Ap+pvcKZ1H01pftwYxCWCou/wOwBeH659bQUgAcsxiZzWZ46aZs0HykyXIb6sSwNQTISA6GS944vD9BRu36oWG0FqfA/DTwb26NiArFUA41TQAlm1AnrouUPw2FARH861NBQHw1mHAb1rrM1I7TMnJSoPgyN6UCiJu+Pd7i4uL+wAsBYBIrUBcXAvAVwCn9oDxAZFauZZp2bgM+kFrfTIHxgsER3M+mgoiR9sMA/8Do7WmDwiO5rvlLSBmYXxBcJRvXZgKQvKo5XGaB/Nx8jcjiuP4LMnvZUHANkUxuzJzt0R2Ril12kCcL3MnOLJ1KwizK52Ckw1IPiP5q2SIFMA1axApXuaxsCI5cG6rBkge/ZxW/2k+bFW9eI5te+YmtzSU5wAgFdNaX4qKCMD9qiFI3omKymS2mxVCbJTSMp1oYvdDQwDol/6ITh4rSDAKCLFZWic+K9likvcCQCyV5k57SRrKPvrCALYKn06uMtG/W1IGMJBglyRJIyhEFkhyM+kAumTN5tp1aYFW+ng6T3LCSK1gdmoZwOrEHwZWzXtduUbKhdxBatWqFfnQH7aZRyLPDeBTAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/Ok.409a1d0a189419edc0ef66a57ec3dc82.svg";
export { ForwardRef as ReactComponent };